import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { OccTransportDamageAdapter } from './adapters/impl/occ-transport-damage.adapter';
import { TransportDamageAdapter } from './adapters/transport-damage.adapter';

@NgModule({ imports: [CommonModule], providers: [
        {
            provide: TransportDamageAdapter,
            useClass: OccTransportDamageAdapter,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class OccModule {}
